module.exports = __webpack_public_path__ + "img/charging1.ca0e92a4.gif";